document.addEventListener("DOMContentLoaded", function () {
    var popup = document.getElementById("video-popup");
    var btn = document.getElementById("open-video-popup");
    var close = document.getElementById("close-video-popup");
    var video = document.getElementById("video-player");

    if (btn && popup && close && video) {
        // Open the video pop-up and play the video
        btn.addEventListener("click", function () {
            popup.style.display = "flex";
            lockScreenOrientation();
            video.play();
        });

        // Close the pop-up when the close button is clicked
        close.addEventListener("click", function () {
            closePopup();
        });

        // Close the pop-up when clicking outside the video
        window.addEventListener("click", function (event) {
            if (event.target === popup) {
                closePopup();
            }
        });

        // Function to close the pop-up and stop video
        function closePopup() {
            popup.style.display = "none";
            stopVideo();
            unlockScreenOrientation();
        }

        // Function to stop the video completely
        function stopVideo() {
            video.pause(); // Pause the video
            video.currentTime = 0; // Reset video to start
            video.load(); // Ensure the video fully resets (hard stop)
        }

        // Function to lock screen orientation to landscape when video plays
        function lockScreenOrientation() {
            if (screen.orientation && screen.orientation.lock) {
                screen.orientation.lock("landscape").catch(function (error) {
                    console.log("Orientation lock not supported:", error);
                });
            }
        }

        // Function to unlock screen orientation when video stops
        function unlockScreenOrientation() {
            if (screen.orientation && screen.orientation.unlock) {
                screen.orientation.unlock();
            }
        }
    } else {
        console.error("Popup elements not found!");
    }
});
